import { useT } from "../i18n";
import type { FolderNode } from "./folder-tree";

// The vault's folder/device tree as a flat indented picker. Shared by MoveDialog and the item
// editor's destination row so "where does this land?" looks the same in both places.
export function FolderPicker({
  value,
  folders,
  onChange,
  className = "",
  ariaLabel,
}: {
  value: string | null;
  folders: FolderNode[];
  onChange: (folderId: string | null) => void;
  className?: string;
  ariaLabel?: string;
}) {
  const t = useT();
  return (
    <select
      value={value ?? ""}
      aria-label={ariaLabel}
      onChange={(e) => onChange(e.target.value || null)}
      className={`rounded border border-border bg-panel2 px-2 py-1 outline-none focus:border-accent ${className}`}
    >
      <option value="">{t("(root)")}</option>
      {folders.map((f) => (
        <option key={f.id} value={f.id}>
          {"— ".repeat(f.depth)}
          {f.kind === "device" ? "🖧 " : "📁 "}
          {f.name}
        </option>
      ))}
    </select>
  );
}
